import React from 'react';
import './ToolTip.css';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import CloseIconBlack from '../../assets/icons/close-grey.svg';

export function ToolTip({content, position, header, tooltipIcon}) {
  const popover = (
    <Popover>
      <Popover.Body>
        <div slot='body' className='prequal--web--tooltip-body'>
          <div
            data-testid='prequal--web--tooltip-header-container'
            className={header ? 'prequal--web--tooltip-header' : 'prequal--web--tooltip-header prequal--web--tooltip-header-no-text'}
          >
            {header && (
              <h2 id='fo-mo-tip-label' className='prequal--web--tip--dialog--header'>
                {header}
              </h2>
            )}
            <button type='button' onClick={() => document.body.click()} className='prequal--web--tooltip-close' tabIndex='-1'>
              <img src={CloseIconBlack} alt='close' />
            </button>
          </div>

          <p className='prequal--wc--tooltip-content'>{content}</p>
        </div>
      </Popover.Body>
    </Popover>
  );

  return (
    <OverlayTrigger trigger={['click']} placement={position} overlay={popover} rootClose>
      <button type='button' className='prequal--web--info-icon' data-testid='prequal--web--info-icon' tabIndex='-1'>
        <img src={tooltipIcon} alt='tooltip-icon' data-testid='tooltip-icon' />
      </button>
    </OverlayTrigger>
  );
}
